import { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const DEFAULT_FILTERS = [
  { label: 'Client', fieldKey: 'client' },
  { label: 'Status', fieldKey: 'status' },
  { label: 'Carrier', fieldKey: 'carrier' },
  { label: 'Origin Port', fieldKey: 'originPort' },
  { label: 'Destination Port', fieldKey: 'destinationPort' },
];

export const useTableFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedFilters, setSelectedFilters] = useState<{ fieldKey: string; optionValue: string }[]>(() => {
    const filters: { fieldKey: string; optionValue: string }[] = [];
    searchParams.forEach((value, key) => {
      filters.push({ fieldKey: key, optionValue: value });
    });
    return filters;
  });
  const handleFilterChange = useCallback(
    (fieldKey: string, optionValue: string) => {
      const existingFilter = selectedFilters.find(
        (filter) => filter.fieldKey === fieldKey && filter.optionValue === optionValue,
      );
      if (existingFilter) {
        setSelectedFilters((prev) => prev.filter((filter) => filter !== existingFilter));
      } else {
        setSelectedFilters((prev) => [...prev, { fieldKey, optionValue }]);
      }
    },
    [selectedFilters],
  );

  const handleClearAll = useCallback(() => {
    setSelectedFilters([]);
  }, []);

  const handleRemoveFilter = useCallback(
    (fieldKey: string, optionValue: string) => {
      setSelectedFilters((prev) => {
        const existingFilter = selectedFilters.find(
          (filter) => filter.fieldKey === fieldKey && filter.optionValue === optionValue,
        );

        if (existingFilter) {
          return prev.filter((filter) => filter !== existingFilter);
        }
        return prev;
      });
    },
    [selectedFilters],
  );

  const selectedFilterCount = useCallback(
    (fieldKey: string) => selectedFilters.filter((filter) => filter.fieldKey === fieldKey).length,
    [selectedFilters],
  );

  useEffect(() => {
    const newParams = new URLSearchParams();
    selectedFilters.forEach((filter) => {
      newParams.append(filter.fieldKey, filter.optionValue);
    });
    setSearchParams(newParams, { replace: true });
  }, [selectedFilters, setSearchParams]);

  return {
    selectedFilters,
    setSelectedFilters,
    handleFilterChange,
    handleClearAll,
    handleRemoveFilter,
    selectedFilterCount,
  };
};
